// redux/slices/languageSlice.js
import { createSlice } from "@reduxjs/toolkit";

const languageSlice = createSlice({
  name: "language",
  initialState: { value: "RO" }, // Default language
  reducers: {
    setLanguage: (state, action) => {
      state.value = action.payload; // Change language based on payload
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
